import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const ResolvableMissionTypeForm_ServiceUsage_MoveToGroup_Mutation =
  graphql(`
    mutation ResolvableMissionTypeForm_ServiceUsage_MoveToGroup(
      $serviceUsageId: Id!
      $serviceUserId: Id!
      $targetServiceUsagesGroupId: Id!
      $versionData: VersionDataInput
    ) {
      moveResolvableMissionTypeServiceUsageToGroup(
        serviceUsageId: $serviceUsageId
        serviceUserId: $serviceUserId
        targetServiceUsagesGroupId: $targetServiceUsagesGroupId
        versionData: $versionData
      ) {
        _id
      }
    }
  `);

export const useMoveResolvableMissionTypeServiceUsageToGroupMutation = () =>
  useGraphQLMutation(
    ResolvableMissionTypeForm_ServiceUsage_MoveToGroup_Mutation,
  );
